import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`Welcome back, ${u.name}!`);
      if (u.role === 'admin') navigate('/admin');
      else if (u.role === 'trainer') navigate('/trainer');
      else navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-side">
        <div>
          <div className="tag">Learn · Grow · Certify</div>
          <h1>HillBoat <span style={{ color: 'var(--accent)' }}>Study.</span></h1>
          <p style={{ opacity: 0.8, fontSize: '1.1rem', maxWidth: 380 }}>
            A modern learning platform built for ambitious students, expert trainers, and growing teams.
          </p>
        </div>
        <ul>
          <li>→ Browse expert-led courses across categories</li>
          <li>→ Track progress with built-in quizzes</li>
          <li>→ Earn verifiable certificates</li>
          <li>→ Dedicated dashboards for every role</li>
        </ul>
      </div>
      <div className="auth-form-wrap">
        <form className="auth-form" onSubmit={handleSubmit}>
          <img
            src="https://www.hillboat.com/assets/logotext-BkzMMB-0.svg"
            alt="HillBoat Study"
            className="auth-logo"
          />
          <h2>Welcome back</h2>
          <p className="subtitle">Sign in to continue your learning journey.</p>

          <div className="form-group">
            <label>Email</label>
            <input
              className="input"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              placeholder="you@example.com"
            />
          </div>
          <div className="form-group">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <label>Password</label>
              <Link to="/forgot-password" style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--accent)' }}>
                Forgot password?
              </Link>
            </div>
            <div style={{ position: 'relative' }}>
              <input
                className="input"
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                placeholder="••••••••"
                style={{ paddingRight: '3.25rem' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((s) => !s)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                style={{
                  position: 'absolute',
                  right: '0.75rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  color: 'var(--ink-soft)',
                }}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%' }}>
            {loading ? <span className="spinner"></span> : 'Sign in →'}
          </button>

          <p className="text-center mt-3 text-muted">
            Don't have an account? <Link to="/register">Create one</Link>
          </p>

          <div className="card mt-3" style={{ background: 'var(--bg)', padding: '1rem', fontSize: '0.8rem' }}>
            <strong style={{ display: 'block', marginBottom: '0.5rem' }}>Demo accounts</strong>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', color: 'var(--ink-soft)' }}>
              <div>Admin &nbsp;·&nbsp; admin@lms.com / admin123</div>
              <div>Trainer &nbsp;·&nbsp; trainer@lms.com / trainer123</div>
              <div>Student &nbsp;·&nbsp; user@lms.com / user123</div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
